"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.roleTypes = exports.boldTypes = exports.types = void 0;
var types;
exports.types = types;

(function (types) {
  types["SmallCaps"] = "small-caps";
  types["XtraSmall"] = "xs";
  types["Small"] = "s";
  types["Medium"] = "m";
  types["Large"] = "l";
  types["ExtraLarge"] = "xl";
})(types || (exports.types = types = {}));

var boldTypes;
exports.boldTypes = boldTypes;

(function (boldTypes) {
  boldTypes["light"] = "fwLight";
  boldTypes["regular"] = "fwRegular";
  boldTypes["medium"] = "fwMedium";
  boldTypes["bold"] = "fwBold";
  boldTypes["black"] = "fwBlack";
})(boldTypes || (exports.boldTypes = boldTypes = {}));

var roleTypes;
exports.roleTypes = roleTypes;

(function (roleTypes) {
  roleTypes["ALERT"] = "alert";
  roleTypes["STATUS"] = "status";
})(roleTypes || (exports.roleTypes = roleTypes = {}));